var map = {
	"./icon-address.svg": "dd16",
	"./icon-email.svg": "2ed8",
	"./icon-facebook.svg": "9c81",
	"./icon-instagram.svg": "3b08",
	"./icon-linkedin.svg": "cbff",
	"./icon-tel.svg": "3e09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c43";